import React from "react";
import NotFound from "../layout/not-found/notFound";
import { RoleKey } from "../models/role";

export interface Route {
  path: string;
  exact?: boolean;
  Component?: React.FC;
  roles?: RoleKey[];
  children?: Route[];
}

export class EffectiveRoute {
  path: string;
  exact?: boolean;
  Component: React.FC;
  roles?: RoleKey[];

  constructor(path: string, Component: React.FC, roles?: RoleKey[], exact?: boolean) {
    this.path = path;
    this.exact = exact;
    this.Component = Component;
    this.roles = roles;
  }
}

export function getEffectiveRoutes(routes: Route[]): EffectiveRoute[] {
  return routes.flatMap(r => getEffectiveRoute(r));
}

let fullPath = "";
let effectiveRoles = new Array<RoleKey>();
function getEffectiveRoute(r: Route): EffectiveRoute[] {
  if (r.children) {
    return r.children.flatMap(cr => {
      let effectiveChildRoles = [...effectiveRoles, ...(r.roles?.concat() || []), ...(cr.roles?.concat() || [])];
      if (cr.Component) {
        return new EffectiveRoute(`${fullPath || ""}${r.path}${cr.path}`, cr.Component, effectiveChildRoles, cr.exact);
      }
      fullPath += r.path;
      effectiveRoles = effectiveChildRoles.concat();
      return getEffectiveRoute(cr);
    });
  }
  if (r.Component) {
    return Array.of(new EffectiveRoute(`${fullPath || ""}${r.path}`, r.Component, effectiveRoles.concat(r.roles || []), r.exact));
  }
  return Array.of(new EffectiveRoute("*", NotFound));
}
